import React, { useRef, useState } from "react";
import classnames from "classnames";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CardInfo from "../../../../components/CardInfo";
import { cj } from "../../../../utils/cls";
import { getIntlRejectReason } from "../../../../utils/intlSoft";
import styles from "../../../../components/Table/index.modules.less";

const IntlTableItem = ({ data: item, tabkey }) => {
  const timerRef = useRef(null);
  const [modelShow, setModelShow] = useState({ type: false });
  const { config } = useSelector((state) => state);
  const navigate = useNavigate();

  const configItem = config?.app_status?.find(
    (configRow) => configRow.id == item.app_status_id
  );
  const configType = config?.soft_cate?.find(
    (configRow) => configRow.id == item.app_cate_d
  );
  const rejectReason = getIntlRejectReason(item);

  const showCard = (e) => {
    timerRef.current && clearTimeout(timerRef.current);
    const x = e.target.offsetLeft + 24 - 104;
    const y = e.target.offsetTop + 20;
    timerRef.current = setTimeout(() => {
      setModelShow({
        type: true,
        x,
        y,
        record: item,
      });
    }, 300);
  };

  const hideCard = () => {
    timerRef.current && clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setModelShow({
        type: false,
        x: 0,
        y: 0,
        record: null,
      });
    }, 300);
  };

  return (
    <>
      <div key={item.id} className={cj(styles.bg, styles.l_item)}>
        <div className={styles.l_name}>
          {item.logo_url ? (
            <img width={32} src={item.logo_url} alt="" />
          ) : (
            <img width={32} src="https://p3.ssl.qhimg.com/t01ea0f774a67ee6d1a.png" alt="" />
          )}
          <span>{item.app_name}</span>
          {item.channel == 0 ? <i>测试</i> : ""}
        </div>
        <div className={styles.l_type}>{configType?.name ? configType.name : "----"}</div>
        <div className={styles.l_version}>版本：{item.app_version}</div>
        <div className={styles.l_time}>{item.ctime}</div>
        <div
          style={{ overflow: "visible" }}
          className={classnames(styles.l_state, {
            [styles[`config_${configItem?.id}`]]: !!configItem?.id,
          })}
        >
          <div className={styles.audit}>{configItem?.name}</div>
          {rejectReason ? (
            <div className={styles.auditBox}>
              <img
                className={styles.audit_failed}
                src="https://p1.ssl.qhimg.com/t01b81a8f8144c46b18.png"
                alt=""
              />
              <strong className={styles.reason}>{rejectReason}</strong>
            </div>
          ) : null}
        </div>
        <div className={styles.l_type}>{item.remark ? item.remark : "-"}</div>
        <div
          onClick={() => navigate(`/view/detail/${item.id}`)}
          className={classnames(styles.l_btn)}
        >
          管理
        </div>
      </div>
      {modelShow.type ? (
        <CardInfo
          style={{
            left: modelShow.x,
            top: modelShow.y,
          }}
          pRef={timerRef}
          data={modelShow.record}
          hideCard={hideCard}
          showCard={showCard}
        />
      ) : null}
    </>
  );
};

export default IntlTableItem;
